import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import { ICON_TYPE_PROP_TYPE } from '../icon/constants';
export var ITEMS_PROP_TYPE = PropTypes.arrayOf(PropTypes.shape({
  title: EBPropTypes.translation,
  iconType: ICON_TYPE_PROP_TYPE
}));
export var ICON_TYPES = ICON_TYPE_PROP_TYPE;
export var STYLE_NEUTRAL = 'neutral';
export var STYLE_FILL = 'fill';
export var STYLES = [STYLE_NEUTRAL, STYLE_FILL];
export var SIZE_LARGE = 'large';
export var SIZE_SMALL = 'small';
export var SIZES = [SIZE_SMALL, SIZE_LARGE];